













































































































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { Associate } from '@/data/models/associate.model';
import { CrudService } from '@/data/services/crud.service';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Veicolo } from '@/data/models/veicolo.model';
import { ClassType } from 'class-transformer/ClassTransformer';

import  Note  from '../attori/note/Note.vue';
import { ListService } from '@/data/services/list.service';

@Component({
	components: {
		ValidationProvider,
		ValidationObserver,
		Note
	}
})
export default class VolontarioDetail extends Vue{
	@Inject('CrudService') associateCrudService!: CrudService<Associate>;
	@Inject('CrudService') vehicleCrudService!: CrudService<Veicolo>;
	@Inject('ListService') listService!: ListService;
	@Prop() associateid!: number;
	@Prop() actorid!: number;
	associate: Associate = new Associate();;
	vehicle: Veicolo = new Veicolo();
	vehicleClass: ClassType<Veicolo> = Veicolo;
	types: string[] = [];
	enableEntity: boolean = false;

	constructor() {
		super();
		this.loadTypes();
	}

	@Watch('associateid') 
	onActorChange() {
		if(this.associateid) {
			this.loadAssociate();
		}
	}

	loadTypes() {
		this.listService.getListItemsBySlug('associate.type').then((result: any) => {
			this.types = result.data;
		});
	}

	loadAssociate() {
		this.associateCrudService.getEntity(Associate, 'associate', this.associateid).then((result: any) => {
			if(result.id) {
				this.associate = result;
				this.enableEntity = true;
			}
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	onEnableEntityChange(event: any) {
		if(!event && this.associate.id) {
			this.$buefy.dialog.confirm({
				message: this.$t('warning-associate-delete') as string,
				type: 'is-danger',
				hasIcon: true,
				cancelText: this.$t('annulla') as string,
				onConfirm: () => {
					this.associateCrudService
						.deleteEntity(Associate, 'associate', this.associate)
						.then(() => {
							this.associate = new Associate();
							this.$emit('updateAssociate', this.associate);
							this.$buefy.notification.open({
								message: '' + this.$t('volunteer-deleted'),
								type: 'is-success',
							});
						})
						.catch((error) => {
							this.$buefy.notification.open({
								message: error.msg,
								type: 'is-danger',
							});
						});
				}, 
				onCancel: () => {
					this.enableEntity = true;
				}
			});
		}
	}

	submit() {
		const call = (this.associate!.id) ? 
			this.associateCrudService.saveEntity(Associate, 'associate', this.associate) : 
			this.associateCrudService.createEntity(Associate, 'associate', this.associate);
		call.then(result => {
			this.associate = result;
			this.$emit('updateAssociate', this.associate);
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

}
